<template>
    <contrato-detalhar
        :dataServicos="obterDataServicos()"
        rotaListagem="Gescon_Gerentes_Contratos"
        :permiteDetalhar="$temAcessoView('GESCON-GER-CONT-00')"
    ></contrato-detalhar>
</template>

<script>
import ContratoDetalhar from '../../contratos/ContratoDetalhar2'
import ContratosServicos from './ContratosServicos'

export default {
    components: {
        ContratoDetalhar
    },

    methods: {
        obterDataServicos() {
            return ContratosServicos
        }
    }
}
</script>